import script from "./ReviewsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewsView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__